import { render, staticRenderFns } from "./UsersPosthogDetails.vue?vue&type=template&id=2272f29a"
import script from "./UsersPosthogDetails.vue?vue&type=script&lang=js"
export * from "./UsersPosthogDetails.vue?vue&type=script&lang=js"
import style0 from "./UsersPosthogDetails.vue?vue&type=style&index=0&id=2272f29a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports